/**
 * Enum for user activity Type
 * @readonly
 * @enum {number}
 */
export var UserActivityType;
(function (UserActivityType) {
    UserActivityType[UserActivityType["None"] = 0] = "None";
    UserActivityType[UserActivityType["PageAction"] = 1] = "PageAction";
    UserActivityType[UserActivityType["PageView"] = 2] = "PageView";
})(UserActivityType || (UserActivityType = {}));
//# sourceMappingURL=UserActivityType.js.map